export const SYSTEM_ROLES = ['Pending', 'Admin', 'User'] as const;
